import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import nl from './locales/nl.json';
import en from './locales/en.json';
import fr from './locales/fr.json';

// Taal wordt onthouden in localStorage; standaard Nederlands voor iedereen
// die nog geen keuze gemaakt heeft.
const STORAGE_KEY = 'smartstays_language';
const savedLanguage =
  (typeof window !== 'undefined' && window.localStorage.getItem(STORAGE_KEY)) || 'nl';

i18n.use(initReactI18next).init({
  resources: {
    nl: { translation: nl },
    en: { translation: en },
    fr: { translation: fr },
  },
  lng: savedLanguage,
  fallbackLng: 'nl',
  interpolation: {
    escapeValue: false,
  },
});

// Helper om overal in de app de taal te wisselen en te onthouden.
export const changeLanguage = (lng) => {
  i18n.changeLanguage(lng);
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(STORAGE_KEY, lng);
  }
};

export default i18n;
